import { PaymentSystemName } from '@campaign-portal/namespace/common/enums';
import { ThemeType } from '@campaign-portal/namespace/entities/portals/specs';

export function paymentSystemSmallIcon(type: PaymentSystemName, theme?: ThemeType): string {
	switch (type) {
		case PaymentSystemName.STRIPE:
			return 'icon-' + type + '-small';
		case PaymentSystemName.PAYPAL:
		case PaymentSystemName.REVOLUT:
		case PaymentSystemName.TRIPLE_A: {
			const palette = theme === 'light' ? 'dark' : 'light';
			return 'icon-' + type + '-small-' + palette;
		}
		default:
			return 'icon-' + type;
	}
}
